import {observable, action, computed} from 'mobx'
import {message} from 'antd'
import report from '@/utils/log'


import {ProductType, ProductInfoTypes, DeviceTypes} from '@/types/RenewalTypes'
import {getRenewList, getDevicePrices, orderRenew} from '@/services/Renewal'
import Userstore from '../index'
import DeviceStore from '../../device'
import {PricesType} from "@/types/NewMachineTypes";
import PayType from "@/types/PayType";

class Renewal {
  @observable productList: ProductInfoTypes[] = []
  @observable deviceList: (DeviceTypes[])[] = []
  @observable productId: string | number // 选择分组的key
  @observable activeIndex: number = 0 // 选择的分组的下标
  @observable productIds: number[] = [] // 选择的云机id列表
  @observable allkeys: number[] = [] // 当前组下的所有id
  @observable renewalModel: boolean = false
  @observable prices: PricesType[] = [] // 套餐列表
  @observable priceId: number|undefined // 选择的套餐id
  @observable price: number  = 0 // 价格
  @observable payType: PayType = 1 // 支付方式

  @computed get getDeviceList(): DeviceTypes[] {
    return this.deviceList[this.activeIndex] || []
  }
  // 价格展示
  @computed get totalPrice(): string {
    return ((this.productIds.length * this.price) / 100).toFixed(2)
  }

  // 页面进入时 设置选择的云机列表  当云机列表不存在时 从本地取云机id列表
  @action.bound initProductIds() {
    if(!this.productIds.length) {
      let productIds = window.sessionStorage.getItem('RenewalProductIds')
      if(productIds){
        this.productIds = JSON.parse(productIds)
        // 设置选择分组的key
        let productId = window.sessionStorage.getItem('RenewalProductId')
        if(productId) this.productId = JSON.parse(productId);
      }
    }
  }

  // 数据初始化
  @action.bound initData() {
    this.productList = []
    this.deviceList = []
    this.activeIndex = 0
    this.productIds = []
    this.allkeys = []
    this.priceId = undefined
    this.price = 0
    this.payType = 1
  }

  // 修改弹框显示
  @action.bound
  async toggoleRenewalModel(bool: boolean = false) {
    this.renewalModel = bool
    if(!bool) {
      // 点击取消 事件上报
      report({
        eventId: 'E1202',
        pageId: 'P12',
        ext: '',
      })
    }
  }

  // 获取分组列表
  @action.bound
  async getRenewList() {

    if (!DeviceStore.DeviceBaseStore.deviceListLen) {
      message.info('当前分组暂无设备');
      return;
    }

    this.initData()
    let params = {
      groupId: Userstore.GroupStore.activeGroupId
    }
    let [error, result] = await getRenewList(params)
    if (error) return;
    const res: ProductType[] = result || []
    let productList: ProductInfoTypes[] = []
    let deviceList: (DeviceTypes[])[] = []
    res.forEach(item => {
      productList.push(item.productInfo)
      deviceList.push(item.deviceList)
      return null
    })
    this.productList = productList;
    this.deviceList = deviceList
    this.productId = this.productList[0] && this.productList[0].productId
    this.activeIndex = 0
    this.allkeys = (deviceList[0] && deviceList[0].map(device => device.id)) || []
    this.toggoleRenewalModel(true)

    // 续费弹框显示成功 事件上报
    report({
      eventId: 'E1200',
      pageId: 'P12',
      ext: '',
    })
  }

  // 获取设备价格点列表
  @action.bound async getDevicePrices() {
    let params = {
      product_id: this.productId,
      scenes: 2
    }
    const [error, result] = await getDevicePrices(params)
    if(error) {
      //续费套餐列表获取失败 事件上报
      report({
        eventId: 'E1503',
        pageId: 'P15',
        ext: '',
      })
      return ;
    }

    this.prices = result.price_list || []

    //续费套餐列表获取成功 事件上报
    report({
      eventId: 'E1501',
      pageId: 'P15',
      ext: '',
    })
  }

  // 修改分组
  @action.bound
  async changeProduct(id: string, index: number) {
    this.productId = id
    this.activeIndex = index
    this.allkeys = this.getDeviceList.map(device => device.id)
    this.productIds = []
  }

  // 修改选择的设备
  @action.bound
  async changeproductIds(arr: number[]) {
    this.productIds = arr
  }

  // 点击全选
  @action.bound
  async toggleAllCheck(bool: boolean) {
    console.log(bool)
    this.productIds = bool ? this.allkeys : []
  }

  // 修改购买套餐
  @action.bound async changePriceId(id: number, options: any) {
    this.priceId = id
    this.price = this.prices[options.key].real_price
  }
  //  切换支付方式
  @action.bound async togglePayType(type: PayType) {
    this.payType = type
  }

  // 点击确认支付
  @action.bound async deviceBuy(){
    if(!this.priceId && this.priceId!==0){
      message.info('请选择套餐')
      return ;
    }
    let params = {
      groupId: Userstore.GroupStore.activeGroupId,
      priceId: this.priceId,
      payType: this.payType,
      priceType: 2,
      clientType: 1,
      totalNum: this.productIds.length,
      returnUrl: window.location.href,
      ids: this.productIds.slice().join(','),
      roomId: JSON.parse(localStorage.getItem('activeRoom')||'{}').id
    }
    const [error, result] = await orderRenew(params)
    if(error) {
      // 续费支付url获取失败 事件上报
      report({
        eventId: 'E1504',
        pageId: 'P15',
        ext: '',
      })
      return ;
    }

    // 续费支付url获取成功 事件上报
    report({
      eventId: 'E1502',
      pageId: 'P15',
      ext: '',
    })

    // 如果是支付宝支付
    if(this.payType === 1){
      window.open(result.request_url)
      return ;
    }
    // 如果是微信支付
    window.open(`/WeixinPay/${this.totalPrice}/${result.order_id}/${encodeURIComponent(result.request_url)}`)
  }

}


export default Renewal
